import { supabase } from '../auth/supabaseClient'

const KEY = 'pt_daily_goal'

export async function getDailyGoal(): Promise<number> {
  try {
    const { data: auth } = await supabase.auth.getSession()
    if (auth.session) {
      const { data, error } = await supabase
        .from('profiles')
        .select('daily_goal_reps')
        .eq('user_id', auth.session.user.id)
        .maybeSingle()
      if (!error && data && typeof (data as any).daily_goal_reps === 'number') return (data as any).daily_goal_reps
    }
  } catch { /* ignore */ }
  try { return parseInt(localStorage.getItem(KEY) || '0', 10) || 0 } catch { return 0 }
}

export async function setDailyGoal(goal: number): Promise<void> {
  try { localStorage.setItem(KEY, String(goal)) } catch { /* ignore */ }
  try {
    const { data: auth } = await supabase.auth.getSession()
    if (auth.session) {
      // Update only; do not create a new row (profiles has NOT NULL fields). Ignore if no row exists yet.
      const { error } = await supabase
        .from('profiles')
        .update({ daily_goal_reps: goal })
        .eq('user_id', auth.session.user.id)
      if (error) throw error
    }
  } catch { /* ignore */ }
}
